/** Le classi condivise della raccolta «Editoriali»
 *  (app/editoriali). Modulo senza direttiva: le leggono Server
 *  e Client Component (stessa ragione di components/rullo/stile.ts).
 *
 *  Misure dal riferimento, uploads/Editoriali_settimanali_OI.html, lette
 *  calcolate in headless (/tmp/pwmeas/ed-rif.js). Il riferimento usa
 *  Georgia, Arial e il monospazio di sistema: qui sono Gelasio
 *  (`font-serif`, metrico di Georgia, già caricato dal layout), Geist
 *  (`font-sans`) e JetBrains Mono (`font-mono`). I colori sono le utility
 *  di sempre, che puntano ai toni `--oi-home-*` della prima pagina;
 *  `.oi-editoriali` aggiunge solo il pannello incassato e la fascia
 *  della controdomanda (globals.css, blocco «EDITORIALI»). */

import { CORNICE_HOME, FUOCO_HOME } from "@/components/home/stile";

/** Il contenitore è la cornice della testata (`CORNICE_HOME`), come sul
 *  Rullo. Era 1280 con 48 pixel di margine, preso dal riferimento: ma la
 *  barra sopra questa pagina è quella della prima pagina, 1440 con 32 di
 *  margine, e il contenuto restava 96 pixel più in dentro per lato a
 *  1440 e a 1920, 16 da 1280 in giù, 5 sul telefono. Misurato con
 *  /tmp/pwmeas/ed-indice.js: ora i bordi coincidono con testata e piede
 *  a ogni larghezza. */
export const CORNICE_EDITORIALI = CORNICE_HOME;

/** L'etichetta mono maiuscola del riferimento (`.small`): 11 pixel,
 *  spaziatura 1,3 pixel. */
export const ETICHETTA_ED = "font-mono text-[11px] leading-[1.65] uppercase tracking-[0.12em]";

/** La stessa a 10 pixel: firme, riepilogo dei risultati, targa
 *  dell'anteprima. Una classe a parte e non un `text-[10px]` accodato
 *  alla prima: due corpi arbitrari sullo stesso elemento li decide
 *  l'ordine del CSS generato, non l'ordine in cui sono scritti. */
export const ETICHETTA_ED_10 = "font-mono text-[10px] leading-[1.65] uppercase tracking-[0.12em]";

/** Il fuoco da tastiera: il contorno sabbia della prima pagina. */
export const FUOCO_ED = FUOCO_HOME;

/** Un pulsante di contorno della paginazione: pannello, bordo, 14 pixel,
 *  alto almeno 44 (area di tocco), sabbia al passaggio. */
export const TASTO_ED =
  "inline-flex min-h-[44px] items-center justify-center gap-2 border border-rule bg-surface px-5 font-sans text-[14px] text-ink no-underline transition-colors hover:border-sabbia hover:text-accent max-[499px]:px-2.5 max-[499px]:text-[12px]";
